<script setup>
import { apiQuery } from "@/api/j24api";
import { ref, defineProps, defineModel, onMounted, watch } from "vue";

const versions = ref([]);
const disabled = ref(true);
const loading = ref(false);
const placeholder = ref("");
const noVersions = ref(false);

const model = defineModel();
const props = defineProps({
  appId: String,
  stream: String,
});

onMounted(async () => {
  if (props.appId && props.stream) {
    await updateVersions();
  }
});

async function updateVersions() {
  loading.value = true;
  noVersions.value = false;
  versions.value.length = 0; // Clear previous versions

  let result = await apiQuery("ELA", "patching/patchingManagement", {
    action: "getAppVersions",
    appId: props.appId,
    stream: props.stream,
  });

  console.log("Versions fetched:", result);
  if (result.versions.length) {
    versions.value.push(...result.versions.reverse());
    disabled.value = false;
    loading.value = false;
    placeholder.value = "Select a version";
  } else {
    placeholder.value = "No versions available";
    disabled.value = true;
    loading.value = false;
    noVersions.value = true;
  }
}

// Watch for changes to stream
watch(
  () => props.stream,
  async (newStream, oldStream) => {
    if (!newStream || newStream === oldStream) {
      return;
    }
    updateVersions();
  }
);
</script>

<template>
  <!-- <v-text-field
            label="Patch to Version"
            variant="outlined"
            hide-details
          ></v-text-field> -->
  <v-select
    v-if="!noVersions"
    :items="versions"
    v-model="model"
    label="Select Version"
    hide-details
    variant="outlined"
    placeholder="placeholder"
    :disabled="!props.stream || disabled"
    :loading="loading"
  ></v-select>
  <v-text-field
    v-else
    label="No versions available"
    placeholder="No versions available"
    variant="outlined"
    hide-details
    disabled
  />
</template>
